import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

// Callables en firebase/functions/src/support-chat.ts
export const openSupportChat = (userId, targetType) =>
  httpsCallable(functions, 'openSupportChat')({ userId, targetType }).then((r) => r.data);

export const closeSupportChat = (userId) =>
  httpsCallable(functions, 'closeSupportChat')({ userId }).then((r) => r.data);

export const sendSupportMessage = (userId, text) =>
  httpsCallable(functions, 'sendSupportMessage')({ userId, text }).then((r) => r.data);

/**
 * Abre el chat y lleva al panel de soporte. Si ya habia uno abierto con ese
 * usuario, simplemente navega hasta el.
 */
export async function openSupportChatAndGo(navigate, userId, targetType) {
  const ok = window.confirm(
    'Se abrirá un chat de soporte y la app del usuario quedará bloqueada hasta que lo cierres. ¿Continuar?'
  );
  if (!ok) return;

  try {
    const { status } = await openSupportChat(userId, targetType);
    if (status === 'pending_trip') {
      alert('El usuario está en un viaje. El chat se abrirá automáticamente cuando termine.');
    }
  } catch (error) {
    if (error.code !== 'functions/already-exists') {
      console.error('Error abriendo chat de soporte:', error);
      alert('Error al abrir el chat: ' + error.message);
      return;
    }
  }
  navigate(`/support?uid=${encodeURIComponent(userId)}`);
}
